package com.essntl.uikit.components.dropdown

import androidx.compose.foundation.background
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.PopupProperties
import com.essntl.uikit.components.input.EsInput

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EsExposedDropDown(
    expanded: Boolean,
    onExpand: (Boolean) -> Unit,
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String? = null,
    showDropDown: Boolean = true,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    onClear: () -> Unit = {},
    dropDownContent: @Composable ColumnScope.() -> Unit,
) {
    ExposedDropdownMenuBox(
        expanded = expanded,
        onExpandedChange = { onExpand(it) },
    ) {
        EsInput(
            value = value,
            interactionSource = interactionSource,
            onClear = onClear,
            onValueChange = onValueChange,
            placeholder = placeholder,
            modifier = Modifier
                .menuAnchor()
                .fillMaxWidth(),
        )

        if (showDropDown)
            DropdownMenu(
                modifier = Modifier
                    .background(Color.White)
                    .exposedDropdownSize(true)
                    .padding(0.dp),
                properties = PopupProperties(focusable = false),
                expanded = expanded,
                onDismissRequest = { onExpand(false) },
            ) {
                dropDownContent()
            }
    }
}